import React, { useContext } from 'react';
import Table from '../../components/Table';
import { GlobalContext } from '../../context/GlobalContext';

export default function Transacciones() {
	const { userData, internal } = useContext(GlobalContext);

	if (!userData?.email) return null;
	const { master_user, sub_stores, store_name } = userData!;

	return (
		<div className="h-full w-full p-4 md:p-6">
			<Table
				userEmail={userData.master_store.id}
				endpoint="https://api.krece.app/tables/transactions/"
				pagination={{ default: 100, batchSizes: [100] }}
				orderBy={{ columnName: 'Fecha Reportado', columnOrder: 'DESC' }}
				filters={[
					{
						column: 'Sucursal',
						options: [
							{ label: 'Todas las sucursales', value: 'Todas las sucursales' },
							...[...(userData?.sub_stores || [])].map((e) => ({ label: e, value: e }))
						],
						defaultValue: 'Todas las sucursales'
					},
					...(userData?.master_user && !userData?.financed_by_krece
						? [
								{
									column: 'Tipo de operación',
									options: [
										{ label: 'Todos los pagos', value: 'Todos los pagos' },
										{ label: 'Pagos en tienda', value: 'Divisas en tienda' },
										{ label: 'Pagos en app', value: 'Reportado en app' }
									],
									defaultValue: 'Todos los pagos'
								}
							]
						: [])
				]}
				filter_by={
					!(!master_user && !sub_stores && store_name && !internal) && userData?.financed_by_krece
						? [{ column_name: 'Tipo de operación', value: 'Divisas en tienda' }]
						: undefined
				}
				search_by={{ column: 'Cedula', placeholder: 'Buscar Cédula...', type: 'numeric' }}
			/>
		</div>
	);
}
